import { render, staticRenderFns } from "./quickConfiguration.vue?vue&type=template&id=27b8fd5b&scoped=true"
import script from "./quickConfiguration.vue?vue&type=script&lang=js"
export * from "./quickConfiguration.vue?vue&type=script&lang=js"
import style0 from "./quickConfiguration.vue?vue&type=style&index=0&id=27b8fd5b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8fd5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b8fd5b')) {
      api.createRecord('27b8fd5b', component.options)
    } else {
      api.reload('27b8fd5b', component.options)
    }
    module.hot.accept("./quickConfiguration.vue?vue&type=template&id=27b8fd5b&scoped=true", function () {
      api.rerender('27b8fd5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/containerTemplateComponent/quickConfiguration.vue"
export default component.exports